import React, { useState } from 'react'
import moment from 'moment'
import styled from 'styled-components'
import TicketCard from './ticket-card.component'
import FontAwesome from 'react-fontawesome'
import { LIGHTGRAY, PRIMARY_COLOR } from '../../../../../styles/colors.style'
import Button from '../../../../../components/buttons/buttons.component'
import ModalConfirmation from '../../../../../components/modal/modal-confirmation.component'

// Bilhetes vindos do fluxo antigo já trazem friendlyDeparture pronto; os da
// MuviHub (me/orders/{id}.tickets[]) só têm o departure em ISO, então
// formatamos aqui como fallback.
function formatDeparture(departure) {
	return departure ? moment(departure).format('DD/MM/YY HH:mm') : ''
}

const ModalTrip = ({ tickets, onReturn, sourceCall, user, isGoing }) => {
	const { friendlyDeparture, origin, destination, boardingPlatform } = tickets[0]
	const departureLabel = friendlyDeparture || formatDeparture(tickets[0].departure)
	let validTicketToCancel = tickets.find(o => o.canReturn == true)
	let canReturnAllTickets = false
	const [showConfirmModal, setShowConfirmModal] = useState(false)
	let ticketId
	const [ticketIdModal, setTicketIdModal] = useState(null)
	const [cancelAllModal, setCancelAllModal] = useState(false)
	const [isGoingModal, setIsGoingModal] = useState(isGoing)

	if (validTicketToCancel) {
		canReturnAllTickets = validTicketToCancel.canReturn
		ticketId = validTicketToCancel.ticketId
	}

	var trechosAgrupados = Object.entries(
		tickets.reduce((prev, curr) => {
			prev[curr.departure]
				? prev[curr.departure].push(curr)
				: (prev[curr.departure] = [curr])
			return prev
		}, {})
	)

	const ehconexao = trechosAgrupados.length > 1

	//se for conexão não pode devolver todos - devolve um a um
	if (ehconexao && canReturnAllTickets) {
		canReturnAllTickets = false
	}

	function onResult(confirmed) {
		setShowConfirmModal(false)
		if (confirmed) {
			onReturn(ticketIdModal, cancelAllModal, isGoing)
		}
	}

	function resumoConexao() {
		var retorno = ''
		trechosAgrupados.forEach(poltronas => {
			var primeiroBilhete = poltronas[1]
			var trechoDepartureLabel =
				primeiroBilhete[0].friendlyDeparture ||
				formatDeparture(primeiroBilhete[0].departure)
			var poltronaCabecalho = (
				<StyledTripInfo className="blue bold">
					<span className="trip-identifier-title">
						{isGoing ? 'Viagem de ida' : 'Viagem de volta'}
					</span>
					<div
						style={{
							display: 'flex',
							marginTop: '5px',
							flexDirection: 'row',
							justifyContent: 'center'
						}}>
						<span className="origin">{primeiroBilhete[0].origin}</span>
						<FontAwesome name="arrow-right" />
						<span className="destination">
							{primeiroBilhete[0].destination}
						</span>
					</div>
					<span className="departure">{trechoDepartureLabel}</span>
					{primeiroBilhete[0].boardingPlatform && (
						<span className="boarding-platform">
							Local de embarque: {primeiroBilhete[0].boardingPlatform}
						</span>
					)}
				</StyledTripInfo>
			)
			retorno = [...retorno, poltronaCabecalho]
			{
				retorno = [
					...retorno,
					poltronas[1].map(
						(
							{
								status,
								bpeKey,
								canReturn,
								trackNumber,
								busSeatNumber,
								passengerName,
								partnerTicketStatus,
								showReeboking,
								originId,
								destinationId,
								calculedPrice,
								ticketId,
								rebookedFrom,
								rebookedTo,
								points,
								buyerId
							},
							index
						) => {
							return (
								<TicketCard
									key={index}
									user={user}
									status={status}
									bpeKey={bpeKey}
									isGoing={isGoing}
									onReturn={onReturn}
									canReturn={canReturn}
									sourceCall={sourceCall}
									trackNumber={trackNumber}
									busSeatNumber={busSeatNumber}
									passengerName={passengerName}
									partnerTicketStatus={partnerTicketStatus}
									showReeboking={showReeboking}
									originId={originId}
									destinationId={destinationId}
									rebookingValue={calculedPrice}
									ticketId={ticketId}
									rebookedFrom={rebookedFrom}
									rebookedTo={rebookedTo}
									points={points}
									buyerId={buyerId}
								/>
							)
						}
					)
				]
			}
		})

		return retorno
	}

	function resumoVendaNormal() {
		var retorno = ''

		var poltronaCabecalho = (
			<StyledTripInfo className="blue bold">
				<span className="trip-identifier-title">
					{isGoing ? 'Viagem de ida' : 'Viagem de volta'}
				</span>
				<div
					style={{
						display: 'flex',
						marginTop: '5px',
						flexDirection: 'row',
						justifyContent: 'center'
					}}>
					<span className="origin">{origin}</span>
					<FontAwesome name="arrow-right" />
					<span className="destination">{destination}</span>
				</div>
				<span className="departure">{departureLabel}</span>
				{boardingPlatform && (
					<span className="boarding-platform">
						Local de embarque: {boardingPlatform}
					</span>
				)}
			</StyledTripInfo>
		)
		{
			retorno = [...retorno, poltronaCabecalho]
			{
				retorno = [
					...retorno,
					tickets.map(
						(
							{
								status,
								bpeKey,
								canReturn,
								trackNumber,
								busSeatNumber,
								passengerName,
								partnerTicketStatus,
								showReeboking,
								originId,
								destinationId,
								calculedPrice,
								ticketId,
								rebookedFrom,
								rebookedTo,
								points,
								buyerId
							},
							index
						) => {
							return (
								<TicketCard
									key={index}
									user={user}
									status={status}
									bpeKey={bpeKey}
									isGoing={isGoing}
									onReturn={onReturn}
									canReturn={canReturn}
									sourceCall={sourceCall}
									trackNumber={trackNumber}
									busSeatNumber={busSeatNumber}
									passengerName={passengerName}
									partnerTicketStatus={partnerTicketStatus}
									showReeboking={showReeboking}
									originId={originId}
									destinationId={destinationId}
									rebookingValue={calculedPrice}
									ticketId={ticketId}
									rebookedFrom={rebookedFrom}
									rebookedTo={rebookedTo}
									points={points}
									buyerId={buyerId}
								/>
							)
						}
					)
				]
			}
		}
		return retorno
	}

	return (
		<StyledTrip>
			<ModalConfirmation
				isOpen={showConfirmModal}
				title={'Confirmar cancelamento'}
				onResult={onResult}>
				<span>
					Se você realizar o cancelamento do(s) bilhete(s) de passagem(ns),
					você NÃO conseguirá embarcar no ônibus para viajar.
				</span>
				<br></br>
				<br></br>
				<span>Você deseja prosseguir com o cancelamento?</span>
			</ModalConfirmation>

			{ehconexao ? resumoConexao() : resumoVendaNormal()}
		</StyledTrip>
	)
}

const StyledTrip = styled.div`
	border: 1px solid ${LIGHTGRAY};
	border-radius: 5px;
	padding: 10px;
	margin: 7px 0px;
`
const StyledTripInfo = styled.div`
	text-align: center;
	.trip-identifier-title {
		color: ${PRIMARY_COLOR};
		font-size: 2rem;
	}
	.departure {
		margin-left: 15px;
	}

	.destination {
		margin-left: 5px;
	}

	.origin {
		margin-right: 5px;
	}

	.boarding-platform {
		display: block;
		font-size: 1.3rem;
		color: #666;
		margin-top: 3px;
	}
`

export default ModalTrip
